// 存储更新状态回掉, 重新验证回掉, 重新验证的Promise
export const SWRGlobalState = new WeakMap()
